export function createZoomOutButtonClickedEvent(zoomScale) {
  return {
    eventType: 'ui',
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'zoomOut',
    attributes: {
      zoomScale: zoomScale
    }
  };
}